<template>
  <responsive-modal v-model="visible" title="Integrar Notazz">
    <div class="tool-modal-notazz">
      <a href="https://notazz.com/" target="_blank" class="integration-link">
        Conheça o Notazz
        <i class="ph ph-arrow-square-out" />
      </a>
      <action-dispatcher action="product/get" :parameters="{ limit: 500 }">
        <snow-select
          :disabled="form.id != null"
          id="product-select"
          required
          label="Produto"
          v-model="form.product_id"
          :errors="errors.product_id"
          :options="products.map(({ id, name }) => ({ id, name }))"
        />
      </action-dispatcher>
      <snow-input
        label="Descrição da integração (Opcional)"
        id="description"
        v-model="form.description"
        :errors="errors.description"
      />
      <snow-input
        label="Chave de integração logística (Opcional)"
        id="logistics-key"
        v-model="form.logistics_key"
        :errors="errors.logistics_key"
      />
      <snow-switch
        is-switch
        id="is-split"
        v-model="form.is_split"
        label="Fazer divisão por valor"
      />
      <div v-if="form.is_split" class="my-3">
        <small class="text-secondary">
          Selecione a porcentagem da divisão
        </small>
        <b-form-input
          id="tax-range"
          :min="0"
          :max="100"
          type="range"
          v-model="form.nfe_tax"
        />
        <div class="d-flex justify-content-between small pb-3">
          <span>NFE: {{ form.nfe_tax }} %</span>
          <span>NFSE: {{ form.nfse_tax }} %</span>
        </div>
      </div>
      <snow-select
        v-else
        id="type-select"
        required
        label="Tipo de nota"
        v-model="form.type"
        :errors="errors.type"
        :options="[
          { id: 'nfse', name: 'Nota fiscal de serviço' },
          { id: 'nfe_55', name: 'Nota fiscal de produto' }
        ]"
      />
      <snow-input
        id="token"
        required
        label="Token"
        v-model="form.token"
        :errors="errors.token"
      />
      <div class="snow-submit-buttons mt-3">
        <snow-button
          size="lg"
          class="order-lg-1"
          :disabled="!isValid"
          @click="submit"
          text="Salvar"
        />
        <snow-button
          size="lg"
          text="Cancelar"
          variant="gray"
          class="order-lg-0 order-1"
          @click="
            visible = false;
            clear();
          "
        />
      </div>
    </div>
  </responsive-modal>
</template>
<script>
import { formFields } from "@/functions/helpers";
import documentValidation from "@/mixins/documentValidation";
import { mapState } from "vuex";
export default {
  mixins: [documentValidation],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        [
          "product_id",
          "token",
          "status",
          "description",
          "is_split",
          "nfe_tax",
          "nfse_tax",
          "logistics_key"
        ],
        { is_split: false, nfe_tax: 30, nfse_tax: 70, logistics_key: "" }
      ),
      loading: false,
      visible: false
    };
  },
  watch: {
    value(v) {
      this.visible = v;
    },
    visible(v) {
      this.$emit("input", v);
      if (!v) {
        this.clear();
      } else {
        this.validateCNPJ();
      }
    },
    integrationToEdit(v) {
      if (v) {
        this.form = {
          ...this.form,
          ...v,
          nfe_tax: parseInt(v.nfe_tax) || 0
        };
      }
    },
    "form.nfe_tax": function(v) {
      this.form.nfse_tax = 100 - v;
    }
  },
  computed: {
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.product_id &&
        this.form.token &&
        (this.form.is_split || this.form.type) &&
        this.validDocument
      );
    }
  },
  methods: {
    clear() {
      this.form = {
        is_split: false,
        nfe_tax: 30,
        nfse_tax: 70,
        logistics_key: ""
      };
      this.$emit("clear-edit");
    },
    onSuccess() {
      this.loading = false;
      this.$message.success("A integração foi salva!");
      this.$emit("update-list");
      this.clear();
      this.visible = false;
    },
    submit() {
      let data = {
        ...this.form
      };
      if (!data.is_split) {
        delete data.nfe_tax;
        delete data.nfse_tax;
      } else {
        delete data.type;
      }
      if (!data.logistics_key) delete data.logistics_key;

      let action = "integration/postIntegration";
      if (this.integrationToEdit) {
        action = "integration/putIntegration";
      }

      this.loading = true;
      this.$store
        .dispatch(action, data)
        .then(this.onSuccess)
        .catch(error => {
          const message = error.response.data?.message?.length
            ? error.response.data.message[0]
            : "Erro ao salvar integração";
          this.$message.error(message);
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tool-modal-notazz {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
